// services/inactiveUserService.js
import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

export const getInactiveUserLogs = async (
  page,
  search,
  startDate = "",
  endDate = "",
  sortOrder = "desc",
  limit = 10
) => {
  try {
    const response = await api.get(
      `${API_URL}/users/getInactiveUserLogs`,
      {
        params: {
          page,
          search,
          startDate,
          endDate,
          sortOrder,
          limit, // ✅ dynamic limit
        },
      }
    );

    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};
